/**
 * Shared copy style guide for all AI-generated marketing text.
 *
 * Append COPY_STYLE_GUIDE to any prompt that produces customer-facing copy
 * (headlines, captions, descriptions, CTAs, ad text, etc.)
 *
 * Usage:
 *   import { COPY_STYLE_GUIDE } from './copyStyleGuide';
 *   const prompt = `Write a headline for ...\n\n${COPY_STYLE_GUIDE}`;
 */

export const COPY_STYLE_GUIDE = `
WRITING STYLE — MANDATORY RULES:

1. Write like a real person, not a marketing AI. Use plain, natural language that sounds like something a human copywriter would actually say out loud.

2. BANNED WORDS AND PHRASES — never use these:
   - "elevate" / "elevating"
   - "unlock" / "unlocking"
   - "leverage" / "leveraging"
   - "seamless" / "seamlessly"
   - "revolutionize" / "revolutionizing"
   - "game-changer" / "game-changing"
   - "cutting-edge"
   - "next-level"
   - "supercharge"
   - "empower" / "empowering"
   - "synergy"
   - "holistic"
   - "delve" / "delve into"
   - "dive in" / "dive into" / "deep dive"
   - "reimagine" / "reimagining"
   - "transform" / "transformative"
   - "unleash"
   - "harness"
   - "curated"
   - "bespoke"
   - "robust"
   - "streamline"
   - "optimize your journey"
   - "take it to the next level"
   - "in today's world"
   - "in today's fast-paced"
   - "look no further"
   - "say goodbye to"

3. Instead of hype words, be SPECIFIC. Say exactly what the product does and why it matters. Replace vague excitement with concrete details.
   - BAD: "Elevate your skincare routine with our revolutionary formula"
   - GOOD: "Clears breakouts in 2 weeks — without drying out your skin"

4. Vary sentence length. Mix short punchy lines with longer ones. Don't start every sentence the same way.

5. Sound confident but not salesy. Skip the exclamation marks unless you'd genuinely shout it. One per post maximum.

6. Use the brand's actual voice and tone if provided. If no brand voice is specified, default to conversational and direct — like texting a friend who asked for a recommendation.
`;
